/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";
import * as auth from "../redux/AuthRedux";
import { register } from "../redux/AuthCRUD";
import { Link } from "react-router-dom";

const initialValues = {
  firstname: "",
  lastname: "",
  email: "",
  password: "",
  changepassword: "",
  acceptTerms: false,
};

const registrationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(3, "Ít nhất 3 ký tự")
    .max(50, "Tối đa 50 ký tự")
    .required("Vui lòng nhập tên"),
  lastname: Yup.string()
    .min(3, "Ít nhất 3 ký tự")
    .max(50, "Tối đa 50 ký tự")
    .required("Vui lòng nhập họ"),
  email: Yup.string()
    .email("Email không hợp lệ")
    .min(3, "Ít nhất 3 ký tự")
    .max(50, "Tối đa 50 ký tự")
    .required("Vui lòng nhập email"),
  password: Yup.string()
    .min(3, "Ít nhất 3 ký tự")
    .max(50, "Tối đa 50 ký tự")
    .required("Vui lòng nhập mật khẩu"),
  changepassword: Yup.string()
    .required("Vui lòng xác nhận mật khẩu")
    .oneOf([Yup.ref("password")], "Mật khẩu không khớp"),
  acceptTerms: Yup.bool().required("Bạn phải đồng ý với điều khoản"),
});

export function Registration() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setTimeout(() => {
        register(values.email, values.firstname, values.lastname, values.password)
          .then(({ data: { accessToken } }) => {
            setLoading(false);
            dispatch(auth.actions.login(accessToken));
          })
          .catch(() => {
            setLoading(false);
            setSubmitting(false);
            setStatus("Đăng ký thất bại. Vui lòng thử lại.");
          });
      }, 1000);
    },
  });

  return (
    <form className="form w-100" noValidate onSubmit={formik.handleSubmit}>
      {/* Tiêu đề */}
      <div className="pb-5 pb-lg-15">
        <h3 className="fw-bolder text-dark display-6">Tạo tài khoản</h3>
        <p className="text-muted fw-bold fs-3">Điền thông tin để đăng ký</p>
      </div>

      {formik.status && (
        <div className="mb-lg-15 alert alert-danger">
          <div className="alert-text font-weight-bold">{formik.status}</div>
        </div>
      )}

      {/* Tên */}
      <div className="fv-row mb-5">
        <label className="form-label fs-6 fw-bolder text-dark pt-5">Tên</label>
        <input
          placeholder="Tên"
          type="text"
          autoComplete="off"
          {...formik.getFieldProps("firstname")}
          className={clsx(
            "form-control form-control-lg form-control-solid",
            {
              "is-invalid": formik.touched.firstname && formik.errors.firstname,
              "is-valid": formik.touched.firstname && !formik.errors.firstname,
            }
          )}
        />
        {formik.touched.firstname && formik.errors.firstname && (
          <div className="fv-help-block">{formik.errors.firstname}</div>
        )}
      </div>

      {/* Họ */}
      <div className="fv-row mb-5">
        <label className="form-label fs-6 fw-bolder text-dark pt-5">Họ</label>
        <input
          placeholder="Họ"
          type="text"
          autoComplete="off"
          {...formik.getFieldProps("lastname")}
          className={clsx(
            "form-control form-control-lg form-control-solid",
            {
              "is-invalid": formik.touched.lastname && formik.errors.lastname,
              "is-valid": formik.touched.lastname && !formik.errors.lastname,
            }
          )}
        />
        {formik.touched.lastname && formik.errors.lastname && (
          <div className="fv-help-block">{formik.errors.lastname}</div>
        )}
      </div>

      {/* Email */}
      <div className="fv-row mb-5">
        <label className="form-label fs-6 fw-bolder text-dark pt-5">Email</label>
        <input
          placeholder="Email"
          type="email"
          autoComplete="off"
          {...formik.getFieldProps("email")}
          className={clsx(
            "form-control form-control-lg form-control-solid",
            {
              "is-invalid": formik.touched.email && formik.errors.email,
              "is-valid": formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className="fv-help-block">{formik.errors.email}</div>
        )}
      </div>

      {/* Mật khẩu */}
      <div className="fv-row mb-5">
        <label className="form-label fs-6 fw-bolder text-dark pt-5">Mật khẩu</label>
        <input
          type="password"
          placeholder="Mật khẩu"
          autoComplete="off"
          {...formik.getFieldProps("password")}
          className={clsx(
            "form-control form-control-lg form-control-solid",
            {
              "is-invalid": formik.touched.password && formik.errors.password,
              "is-valid": formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className="fv-help-block">{formik.errors.password}</div>
        )}
      </div>

      {/* Xác nhận mật khẩu */}
      <div className="fv-row mb-10">
        <label className="form-label fs-6 fw-bolder text-dark pt-5">Xác nhận mật khẩu</label>
        <input
          type="password"
          placeholder="Nhập lại mật khẩu"
          autoComplete="off"
          {...formik.getFieldProps("changepassword")}
          className={clsx(
            "form-control form-control-lg form-control-solid",
            {
              "is-invalid":
                formik.touched.changepassword && formik.errors.changepassword,
              "is-valid":
                formik.touched.changepassword && !formik.errors.changepassword,
            }
          )}
        />
        {formik.touched.changepassword && formik.errors.changepassword && (
          <div className="fv-help-block">{formik.errors.changepassword}</div>
        )}
      </div>

      {/* Điều khoản */}
      <div className="fv-row mb-10">
        <div className="form-check form-check-custom form-check-solid mb-5">
          <input
            className="form-check-input"
            type="checkbox"
            id="kt_login_toc_agree"
            {...formik.getFieldProps("acceptTerms")}
          />
          <label
            className="form-check-label fw-bold text-gray-600"
            htmlFor="kt_login_toc_agree"
          >
            Tôi đồng ý với{" "}
            <Link to="/auth/terms" className="ms-1">
              điều khoản sử dụng
            </Link>
            .
          </label>
          {formik.touched.acceptTerms && formik.errors.acceptTerms && (
            <div className="fv-help-block">{formik.errors.acceptTerms}</div>
          )}
        </div>
      </div>

      {/* Nút hành động */}
      <div className="d-flex flex-wrap pb-lg-0 pb-5">
        <button
          type="submit"
          className="btn btn-primary fw-bolder fs-6 px-8 py-4 my-3 me-4"
          disabled={
            formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms
          }
        >
          {!loading && <span className="indicator-label">Đăng ký</span>}
          {loading && (
            <span className="indicator-progress" style={{ display: "block" }}>
              Vui lòng chờ...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>

        <Link to="/auth/login">
          <button
            type="button"
            className="btn btn-light-primary fw-bolder fs-6 px-8 py-4 my-3"
          >
            Hủy
          </button>
        </Link>
      </div>
    </form>
  );
}
